import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/9ca10ab4-f2e9-4229-b7f1-7a94f9c72f33";
export const REGISTER_URL = "https://a.ntrk2.com/4848c5ac-00db-4a85-9394-2eec261d352b";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowpk.loadprkw2a.com/download?openExternalBrowser=1&id=gq1r2a0z66yonqc";

export * from "./codes";
export * from "./context";
